import * as actions from './actionsTypes';

const initialData = {
  loaderDashboard: false,
  dashboardSelectData: {},
  dashboardError: ''
}

export default function DashBoardSelectReducer(state = initialData, action){
    
  switch (action.type) {
    case actions.LOADING_DASHBOARD_SELECT_RESPONSIBLE_BOX:
      return {...state, loaderDashboard: action.payload}
    case actions.GET_DASHBOARD_SELECT_RESPONSIBLE_BOX:
      return {...state, dashboardSelectData: action.payload}
    case actions.DASHBOARD_SELECT_ERROR:
      return {...state, dashboardError: action.payload}
    default:
      return state
  }
}